import Counter from "../../../../content/blog/0006-update-on-event-loop-article/Counter";
import React from 'react';
export default {
  Counter,
  React
};